const CLEAR_EVENT = (state) => {
  state.proposedEvent = {};
  state.proposedErrors = [];
};

export default CLEAR_EVENT;
